import SectionItem from '../../Layout/SectionItem/SectionItem'
import { LuxTextInput, LUX_INPUT_TYPE } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'
import { useEffect } from 'react'

const PhotographicTaskAction = (props: {
    numberOfPhotos: number
    onChangeNumber: (val: string) => void
}) => {
    const intl = useIntl()
    const { numberOfPhotos, onChangeNumber } = props

    useEffect(() => {
        const handleMouseWheel = (e) => {
            e.preventDefault()
        }
        document
            .getElementById('number-of-photos')
            .addEventListener('mousewheel', handleMouseWheel, { passive: false })
        return () => {
            removeEventListener('mousewheel', handleMouseWheel, false)
        }
    }, [])

    return (
        <SectionItem>
            <div className="text mb-3">
                {intl.formatMessage({
                    id: 'ph2.modals.new.activity.creation.action.indicate_photos',
                    defaultMessage: 'Indicate the Number of Photos',
                })}
            </div>
            <LuxTextInput
                type={LUX_INPUT_TYPE.number}
                value={numberOfPhotos}
                onChangeCallback={onChangeNumber}
                label={intl.formatMessage({
                    id: 'ph2.modals.new.activity.creation.action.minimum_photos',
                    defaultMessage: 'Select minimum photos',
                })}
                mandatory
                placeholder={intl.formatMessage({
                    id: 'ph2.modals.new.activity.creation.action.number_of_photos',
                    defaultMessage: 'Number of photos',
                })}
                additionalProps={{
                    id: 'number-of-photos',
                }}
                isInteger
            />
        </SectionItem>
    )
}

export default PhotographicTaskAction
